/*** Can Be Set With Shape Code Start ***/
function getCanBeSetWith(variantData){
  var canBeMatchWith = [];
  $(variantData).each(function(index, variant){
      var shape = variant.option1;
      var metal = variant.option2;

      $('.selected_metal').html(metal);
      $('.selected_shape').html(shape);      
    
      if (jQuery.inArray(shape, canBeMatchWith) !== -1) {
      }else{
        canBeMatchWith.push(shape);
      }
      
      if (index === (variantData.length - 1)) {        
        if(canBeMatchWith != ''){
          var canbematchwith = canBeMatchWith.join(",");
          $('#can_be_match_with').val(canbematchwith); //setting match with diamond shape
        }     
      }    
  });
}
/*** End ***/

/*** Gallery Images Changes As Per Metal Change ***/
function filterMedia(variantId,variantData,productMedia){ 
  $('.tps_variant_metafields').hide();
  $('.tps_variant_metafield_'+variantId).show();
  
  if(jQuery(window).width() <= 767){ 
    mobileGallery(variantId,variantData,productMedia);
    return false;
  }
  $('[thumbnail-color]').hide(); 
  
  $(variantData).each(function(index, variant){   
    if(variant.id == variantId){      
     
      /*** varient gallery image set on change start ***/          
      if(variant.featured_media != null || variant.featured_media != undefined){
        var selected_variant = variant.featured_media.alt;
        var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
        var selected_variant_price = variant.price;
        $('#variant_price').val(selected_variant_price);
        
        if(variant.featured_media.alt == null){                     
          $('.variant_with_no_image').show();
        }else{          
          productImage = '<img src="'+variant.featured_media.preview_image.src+'" alt="'+variant.featured_media.alt+'">';
          $(".tps_popup_product_image").html(productImage);
          $(selected_attribute).show();
        }    
      }else{
        $('.variant_with_no_image').show();
      }
    }
  });
}
/*** End ***/

/*** Update Product Hidden Values Start ***/
function mobileGallery(variantId,variantData,productMedia) { 
  var variantId = $("select[name='id']").val();
  
  //gallery as per mockup start here
  $(".tps_product_detail_gallery").html('<div class="tps_mobile_gallery_loader_main"><span class="tps_mobile_gallery_loader"></span></div>');
  
  $(variantData).each(function(index, option){        
    
    if(option.id == variantId){   
      
      // var setting_shape = option.option1;
      // var setting_metal = option.option1;      
      
      // setting_metal = setting_metal.toLowerCase();      
          
      //  if(option.featured_media != null && option.featured_media != ''){             
      //    metal_color = option.featured_media.alt;             
      //  }
       
      //  if(metal_color == null){
      //      if (setting_metal.indexOf("18k ") >= 0){ 
      //         var metal_color = setting_metal.replace('18k ','').trim();
      //      }else{
      //         var metal_color = setting_metal;
      //      }    
      //      metal_color = metal_color.toLowerCase(); 
      //      if (setting_metal.indexOf(" /") >= 0){ 
      //         metal_color = metal_color.replace(' /','').trim();
      //      }

      //      if(metal_color == 'platinum'){
      //        metal_color = 'white gold';
      //      }
      //      // metal_color = setting_shape+' - '+metal_color;
      //      metal_color = metal_color;
      //  }         
      
      var gallery_data = new Array();

      if(productMedia != '' && productMedia != null){  
        var metal_color = option.featured_media.alt;
        
          $.each(productMedia, function(key, media){           
            if(metal_color == media.alt){
              if(media.media_type == 'image'){
                gallery_data.push({
                    id: media.id,
                    type: media.media_type,
                    src: media.src,
                    alt: media.alt
                });
              }else{              
                gallery_data.push({
                    id: media.id,
                    type: media.media_type,
                    src: media.sources[0].url,
                    alt: media.alt
               });
              }
            }
          });              
         
          if(gallery_data != ''){
              if(gallery_data.length > 0){
                var galleryMobileHtml = '';  
                galleryMobileHtml += '<div class="tps-gallery-media-div">';

                //gallery main image section start
                $.each(gallery_data, function(key, image){      
                    if(key == 0){
                      galleryMobileHtml += '<div class="tps-gallery-main-image-section">';
                      
                      productImage = '<img src="'+image.src+'" alt="'+image.alt+'">';
                      $(".tps_popup_product_image").html(productImage);
                      
                    }                      
                                           
                    galleryMobileHtml += '<div class="tps-gallery-image tps-gallery-slide-'+key+'"><div class="main-img">';
                    if(image.type == 'image'){   
                      var big_image = image.src;                         
                      big_image = big_image.replace('.jpg','_400x.jpg');                        
                      galleryMobileHtml += '<img src="'+big_image+'" alt="'+image.alt+'" class="tps-gallery-slide-img">';
                    }else{
                      galleryMobileHtml += '<video class="tps-gallery-slide-video" playsinline="playsinline" loop="loop" autoplay="autoplay" muted="muted">';
                      galleryMobileHtml += '<source type="video/mp4" src="'+image.src+'">';
                      galleryMobileHtml += '</video>';
                    }
                    galleryMobileHtml += '</div></div>';        
                    
                    if(gallery_data.length == key){
                      galleryMobileHtml += '</div>'; 
                    }
                });
                //end
                galleryMobileHtml += '</div>';  
                
                galleryMobileHtml += '</div>';
              }
            }
            setTimeout(function(){
              $(".tps_product_detail_gallery").html(galleryMobileHtml);             
              gallerySlickSlider();
            }, 500);
      }else{
          var galleryMobileHtml = '';
          galleryMobileHtml += '<div class="tps-gallery-media-div">';
          galleryMobileHtml += '<div class="tps-gallery-main-image-section">';
          galleryMobileHtml += '<div class="tps-gallery-image tps-gallery-slide-1"><div class="main-img">';
          galleryMobileHtml += '<img class="tps-gallery-slide-img" src="https://diamonds.jewelleryservices.co.nz/cdn/shop/t/6/assets/no-image-placeholder.jpg" width="auto" height="auto">'; 
          galleryMobileHtml += '</div></div>';
          galleryMobileHtml += '</div>';
          galleryMobileHtml += '</div>';
          
          $(".tps_product_detail_gallery").html(galleryMobileHtml); 
      }
    }
  });
  //end
}  

/*** Gallery Slider ***/
function gallerySlickSlider(){
  $('.tps-gallery-main-image-section').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1
    });       
}
/*** End ***/

/*** Sticky Product Info Code Start ***/
$(window).bind('scroll', function() { 
  var headerDiv = jQuery('header');
  var headerDivOuterHeight = headerDiv.outerHeight();    

  // var annoucementDiv = jQuery('.utility-bar');
  // var announcementDivOuterHeight = annoucementDiv.outerHeight();    

  var breadcrumDiv = jQuery('.breadcrumb');
  var breadcrumDivOuterHeight = breadcrumDiv.outerHeight();    

  var headerDivHeight = headerDivOuterHeight + breadcrumDivOuterHeight;    
  
  var scrollY  = jQuery(window).scrollTop();

  /* calculate product meta info div scroll position */
  var sidebarDiv  = jQuery('.product__information');
  var sidebarDivTop = sidebarDiv.offset().top;                        
  var sidebarDivScrollPosition = (sidebarDivTop - headerDivHeight) + 50;

  if (scrollY >= sidebarDivScrollPosition) {
      sidebarDiv.addClass('sticky_info');
  } else {
      sidebarDiv.removeClass('sticky_info');
  }  
});
/*** End ***/

/*** Product Detail Page Info Tabs ***/
jQuery(document).on('click','.tps_product_description_head',function(e){  
  var data_title = jQuery(this).attr("data-title"); 

  if(jQuery(this).hasClass("active")){
    jQuery(this).removeClass("active");
    jQuery(this).find('span').removeClass('tps_arrow_up').addClass('tps_arrow_down');
    jQuery('.tps_product_'+data_title).slideUp();
  }else{
    jQuery(this).addClass("active");
    jQuery(this).find('span').removeClass('tps_arrow_down').addClass('tps_arrow_up');
    jQuery('.tps_product_'+data_title).slideToggle("slow");
  }
});
/*** End ***/

/*** Select Diamond Focus On Diamond Listing ***/
// jQuery(document).on('click','.tps_select_diamond',function(e){
function selectDiamond(){
  var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));    
  var setting_diamond_shape = jQuery("#can_be_match_with").val();
  
  if(diamond_info != null && diamond_info != undefined){
    if(setting_diamond_shape == diamond_info[0].diamond_shape){
      var target = '.tps_ringbuilder_diamond_detail_block'; 
    }else{
      var target = '.tps_ringbuilder_diamond_listing_block'; 
    }
  }else{
    var target = '.tps_ringbuilder_diamond_listing_block';   
  }  
  $('html, body').animate({
      scrollTop: $(target).offset().top 
  }, 'slow'); 
}
// });
/*** End ***/

/*** Select Diamond Focus On Diamond Listing Detail Section ***/
jQuery(document).on('click','.tps_selected_diamond_info_modify',function(e){ 
  var target = '.tps_ringbuilder_diamond_detail_block';  
  $('html, body').animate({
      scrollTop: $(target).offset().top 
  }, 'slow');   
});
/*** End ***/

/*** Deselect Diamond Section ***/
jQuery(document).on('click','.tps_deselect_diam',function(e){   

  // var view_type = localStorage.getItem("ringbuilder_listing_view");
  // $('.diamond_'+view_type+'_view_container').show();
  
  $('.setting_diamond_info').hide(); 
  $('.tps_select_diamond').show();  
  $('.tps_ringbuilder_diamond_detail_block').hide(); 
  $('.tps_ringbuilder_diamond_listing_block').show(); 
  $('.tps_product_detail_diamond_info').hide(); 
  $('.tps_add_to_cart_button').hide(); 
  localStorage.removeItem("ring_diamond");
  $('#page_no').val(1);      
  graphqlDataCall();
  
  var target = '.product__information';  
  $('html, body').animate({
      scrollTop: $(target).offset().top - 0
  }, 'slow'); 
  
});
/*** End ***/

/*** Ring Size HTML Code Start ***/ 
function ringSizeHtml(){
  var ring_sizes = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];

  var ringsizeHtml = '';
  ringsizeHtml += '<ul class="tps_ring_sizes">';
  $.each(ring_sizes, function(i, values) {  
    ringsizeHtml += '<li class="tps_ring_size_swatch tps_ring_size_'+values+'">';
    ringsizeHtml += '<label for="'+values+'">';
    var ring_size = "'"+values+"'";
    ringsizeHtml += '<input type="radio" class="tps_ring_size" name="tps_ring_size" value="'+values+'" data-value="'+values+'">';  
    ringsizeHtml += '<span class="lable-txt">'+values+'</span>';
    ringsizeHtml += '</label>';
    ringsizeHtml += '</li>';
  }); 
  ringsizeHtml += '</ul>';

  $(".tps_ring_size_options").html(ringsizeHtml);        
}
/*** End ***/

/*** Ring Size Tabs Code Start ***/ 
jQuery(document).on('click','.tps_ring_size_changer',function(e){
    if(jQuery(this).hasClass("active")){
      jQuery(this).removeClass("active");
    }else{
      jQuery(this).addClass("active");
    }   
    
    $(".tps_ring_size_options").slideToggle("slow");  
 });
/*** End ***/ 

/*** Ring Size Select Start ***/ 
jQuery(document).on('click','.tps_ring_size',function(e){
  $('.tps_ring_size_swatch').removeClass("selected");
  
  var ring_size = $(this).attr("data-value");
  $('.tps_ring_size_'+ring_size).addClass("selected");
  $(".tps_ring_selected_size").text(ring_size);   
  $("#ring_size").val(ring_size);
});
/*** End ***/ 

/*** Enquire About This Diamond Popup Code Start ***/
jQuery(document).on('click','.tps_enquire_btn',function(){   
  jQuery(".tps_enquire_diamond_popup").addClass("tps_form_popoup_show");
});
/*** End ***/

/*** Enquire About This Ring Popup Code Start ***/
jQuery(document).on('click','.tps_enquire_ring_button',function(){ 
  jQuery('body').addClass("tps_body_no_scroll_effect");
  jQuery(".tps_enquire_diamond_ring_popup").addClass("tps_form_popoup_show");
});
/*** End ***/

/*** Popup Close Code Start ***/
function popoup_form_close(data_popup){
  if(data_popup == 'enquire_diamond_ring'){
    $(".tps_popup_right_section_message").hide();
    $(".tps_popup_body").show();    
  }
  jQuery('body').removeClass("tps_body_no_scroll_effect");
  jQuery(".tps_"+data_popup+"_popup").removeClass("tps_form_popoup_show"); 
}
/*** End ***/

/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    var diamond_id = $(this).data("diamondid");
    var diamond_type = $(this).data("type");
    var diamond_price = $(this).data("price");
  
    $('#choose_diamond').addClass('choose_diamond_spinner');
    $('.tps_choose_diamond_'+diamond_id).addClass('tps_loader_show');    

    var productSku = []; 
    var proceedFlag = 1;
    jQuery.getJSON('/cart.js', function(cart) {
      if(cart.items != ''){ 
        
        $(cart.items).each(function(index, value) { 
           var str = "-";   
           var sku = value.sku;
  
           if(sku.indexOf(str) != -1){                  
             sku = sku.split('-');
             sku = sku[1];                       
           }else{
             var sku = value.sku;      
           }
                     
           if(sku == diamond_id){
             $('#choose_diamond').removeClass('choose_diamond_spinner');
             $('.tps_choose_diamond_'+diamond_id).removeClass('tps_loader_show');
             proceedFlag = 0;
             event.preventDefault();            
             alert("Product already in cart. Please change diamond.");            
           }                              
         });       
      }
    });
  
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_certno": $(this).data("certno"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
        "diamond_type": $(this).data("type"),
        "size" : $(this).data("carat"),
        "diamond_image": $(this).data("image"),
    }];

    // setTimeout(function(){
      if(proceedFlag == 1){   
        localStorage.setItem("ring_diamond", JSON.stringify(diamond));
        $('#choose_diamond').removeClass('choose_diamond_spinner');
        $('.tps_choose_diamond_'+diamond_id).removeClass('tps_loader_show');  
      }   
    // }, 800);

    var ring_setting = localStorage.getItem("ring_setting");
    if(ring_setting != '' && ring_setting != null){
      var setting_info = jQuery.parseJSON(ring_setting);
      var setting_price = setting_info[0].setting_price/100; 
      var setting_product_url = setting_info[0].setting_url;
      var data_flag = $(this).data("flag");
      getFinalRingPrice(setting_price,diamond_price);   

      if(data_flag == "diamond-detail"){
        window.location.href = setting_product_url;
      }else{        
        $('.tps_ringbuilder_diamond_listing_block').hide(); 
        $('.tps_select_diamond').hide(); 
        $('.tps_ringbuilder_diamond_detail_block').show(); 
        $('.tps_add_to_cart_button').show(); 

        graphqlDiamondDetailCall(diamond_id,diamond_type);
        
        var target = '.product__information';  
        $('html, body').animate({
            scrollTop: $(target).offset().top - 0
        }, 'slow'); 
        
      }
        
    }
  
   
});
/****** end of choose diamond *****/

/*** Get Final Ring Price ***/
function getFinalRingPrice(setting_price,diamond_price) {
  var final_ring_price = diamond_price + setting_price;
  final_ring_price = Shopify.formatMoney(final_ring_price*100,theme.moneyFormat);
  $('.tps_final_ring_price').html(final_ring_price);
  return final_ring_price;
}
/*** End ***/

/*** Get Diamond Type ***/
function diamondType(dia_type){
  if(dia_type == 'natural-white'){
    dia_type = 'Natural';
  }else if(dia_type == 'natural-fancy'){
    dia_type = 'Natural Fancy';
  }else if(dia_type == 'lab-white'){
    dia_type = 'Lab';
  }else if(dia_type == 'lab-fancy'){
    dia_type = 'Lab Fancy';
  }
  return dia_type;
}
/*** End ***/

/*** Final Ring Add To cart ***/
function finalProductAddToCart() {
  jQuery(".tps_add_to_cart_loader").addClass('add_to_cart_spinner');

  var setting_info = jQuery.parseJSON(localStorage.getItem("ring_setting"));
  var diamond_info = JSON.parse(localStorage.getItem("ring_diamond")); 

  var diamond_id = diamond_info[0].diamond_id;
  var setting_name = setting_info[0].setting_name;
  var setting_price = setting_info[0].setting_price;
  var setting_sku = setting_info[0].setting_sku;
  var setting_image = setting_info[0].setting_image;
  var setting_metal = setting_info[0].setting_metal_type;  
  var setting_metal = capitalizeFirstLetter(setting_metal);
  var setting_ring_size = '';
  var center_stone = setting_info[0].center_stone;
  var max_carat_weight = setting_info[0].maximum_carat_total_weight;
  var min_carat_weight = setting_info[0].minimum_carat_total_weight;
  var product_id = setting_info[0].product_id;
  var setting_id = setting_info[0].setting_id;
  var setting_url = setting_info[0].setting_url;
  var varient_id = setting_info[0].setting_id;
  var diamond_image = '';
  var diamond_type = diamond_info[0].diamond_type;

  //query parameters for graphql final pendant add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${ringAddToCart}(diamondId: "` +
              diamond_id +
              `",settingName:"` +
              setting_name +
              `",settingPrice:"` +
              setting_price +
              `",settingSku:"` +
              setting_sku +
              `",settingImage:"` +
              setting_image +
              `",settingRingsize:"` +
                setting_ring_size +
                `",centerStone:"` +
              center_stone +
              `",maximumCaratTotalWeight:"` +
              max_carat_weight +
              `",minimumCaratTotalWeight:"` +
              min_carat_weight +
              `",productId:"` +
              product_id +
              `",settingId:"` +
              setting_id +
              `",baseVariantid:"` +
              varient_id +
              `",settingUrl:"` +
              setting_url +
              `",settingMetal:"` +
              setting_metal +
              `",diamondType:"`+diamond_type+`")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId
                     productHandle
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {  
        var variant_id = response.data.ringAddToCart.variantId;          
        var product_handle = response.data.ringAddToCart.productHandle;          
        var message = response.data.ringAddToCart.message;
        
        setTimeout(function(){            
          var productSku = [];
          
         jQuery.getJSON('/cart.js', function(cart) {
           if(cart.items != ''){                     
             $(cart.items).each(function(index, value) { 
               var sku = value.sku;                    
               productSku.push(sku);                                                     
             });
             
             // var final_product_sku = setting_sku+'-'+diamond_id+'-'+setting_ring_size; 
             var final_product_sku = setting_sku+'-'+diamond_id; 
                                                        
             setTimeout(function(){ 
                if($.inArray(final_product_sku, productSku)!=(-1)){ 
                  jQuery(".tps_add_to_cart_loader").removeClass("add_to_cart_spinner");
                  alert("Product already in cart.");  
                }else if($.inArray(diamond_id, productSku)!=(-1)){ 
                  jQuery(".tps_add_to_cart_loader").removeClass("add_to_cart_spinner");
                  alert("Product already in cart.");
                }else{                        
                  addtocart(variant_id);
                }
              }, 10);                    
           }else{               
             addtocart(variant_id);
           }              
          });     
          
        }, 4000);
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);
         jQuery("#add_to_cart_spinner").hide();
       }
    });     
}
/*** End ***/

/*** Add To Cart ***/
function addtocart(add_id){  
  jQuery(".tps_add_to_cart_loader").removeClass('add_to_cart_spinner');
    jQuery.post('/cart/add.js', {
      quantity:1,
      id: add_id,
    });

  setTimeout(function(){
      window.location.href = "/cart";
  }, 1500);  
}
/*** End ***/

/*** Get Daimond ID From Url Start ***/
  function getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }    
/*** End ***/